import type { SVGProps } from 'react'
const SvgHeadsetMic = (props: SVGProps<SVGSVGElement>) => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      height={18}
      id="headset-mic_svg__a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={18}
      x={0}
      y={0}
    >
      <path d="M0 0h18v18H0z" />
    </mask>
    <g mask="url(#headset-mic_svg__a)">
      <path d="M9 17.317v-1.62h5.196v-.75h-3.072V8.74h3.072v-.616q0-2.157-1.52-3.674Q11.159 2.933 9 2.933q-2.148 0-3.672 1.517-1.524 1.518-1.524 3.674v.616h3.072v6.206H3.804q-.708 0-1.208-.499a1.65 1.65 0 0 1-.498-1.207V8.124q0-1.418.546-2.673A7 7 0 0 1 4.13 3.258a7 7 0 0 1 2.195-1.485A6.6 6.6 0 0 1 9 1.227q1.419 0 2.674.543a7 7 0 0 1 2.196 1.482 7 7 0 0 1 1.487 2.194q.546 1.256.545 2.678v7.487q0 .709-.498 1.207a1.64 1.64 0 0 1-1.208.5zM3.804 13.24h1.365v-2.794H3.804zm9.027 0h1.365v-2.794h-1.365z" />
    </g>
  </svg>
)
export default SvgHeadsetMic
